// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard__container {
    display: flex;
    height: 80vh;
    width: 100%;
    align-items: center;
    justify-content: center
}
.dashboard__content {

}
.dashboard__content h1 {
    text-align: center;
    font-size: 2.25rem;
    line-height: 2.5rem;
    font-weight: 200;
    text-transform: capitalize;
    letter-spacing: -0.025em;
    --tw-text-opacity: 1;
    color: rgb(107 114 128 / var(--tw-text-opacity, 1))
}
.dashboard__content p {
    text-align: center;
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 300;
    text-transform: capitalize;
    letter-spacing: 0.025em;
    --tw-text-opacity: 1;
    color: rgb(107 114 128 / var(--tw-text-opacity, 1))
}`, "",{"version":3,"sources":["webpack://./src/pages/DashboardPage/dashboardpage.css"],"names":[],"mappings":"AACI;IAAA,aAAuD;IAAvD,YAAuD;IAAvD,WAAuD;IAAvD,mBAAuD;IAAvD;AAAuD;AAE3D;;AAEA;AAEI;IAAA,kBAAmF;IAAnF,kBAAmF;IAAnF,mBAAmF;IAAnF,gBAAmF;IAAnF,0BAAmF;IAAnF,wBAAmF;IAAnF,oBAAmF;IAAnF;AAAmF;AAGnF;IAAA,kBAA4E;IAA5E,kBAA4E;IAA5E,iBAA4E;IAA5E,gBAA4E;IAA5E,0BAA4E;IAA5E,uBAA4E;IAA5E,oBAA4E;IAA5E;AAA4E","sourcesContent":[".dashboard__container {\n    @apply flex items-center w-full h-[80vh] justify-center;\n}\n.dashboard__content {\n\n}\n.dashboard__content h1 {\n    @apply text-4xl font-extralight tracking-tight capitalize text-gray-500 text-center;\n}\n.dashboard__content p {\n    @apply text-xs font-light tracking-wide capitalize text-gray-500 text-center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
